import React from 'react';
import Hero from '../../components/Hero/Hero';
import heroBg from '../../assets/images/hero/tspc-banner.png';
import rawMaterials from '../../assets/images/process/shared/raw-materials.png';
import escomatic1 from '../../assets/images/process/escomatic/escomatic-machine-1.png';
import escomatic2 from '../../assets/images/process/escomatic/escomatic-machine-2.png';
import heatTreatment from '../../assets/images/process/shared/heat-treatment.png';
import centerlessGrinding from '../../assets/images/process/escomatic/centerless-grinding.png';
import barrel2b from '../../assets/images/process/escomatic/barrel-2b.png';
import washingDrying from '../../assets/images/process/shared/washing-drying.png';
import finalInspection from '../../assets/images/process/shared/final-inspection.png';
import finalPacking from '../../assets/images/process/shared/final-packing.png';
import './Process.css';

const steps = [
  { img: rawMaterials, label: 'Raw Materials' },
  { img: escomatic1, label: 'Escomatic Machine' },
  { img: escomatic2, label: 'Escomatic Machine' },
  { img: heatTreatment, label: 'Heat Treatment (SUS420J2)' },
  { img: centerlessGrinding, label: 'Centerless Grinding Machine' },
  { img: barrel2b, label: 'Barrel 2B' },
  { img: washingDrying, label: 'Washing & Drying' },
  { img: finalInspection, label: 'Final Visual Inspection' },
  { img: finalPacking, label: 'Final Packing' },
];

const EscomaticProcess = () => (
  <div>
    <Hero title={<>Escomatic <span className="highlight">Process</span></>} subtitle="Precision cutting of stainless steel into small diameter parts with chamfer, radius, groove and straight end cut designs." backgroundImage={heroBg} />
    <section className="process section">
      <div className="container">
        <p className="section-label">Manufacturing Process</p>
        <h2 className="section-title">View Our <span className="highlight">Escomatic Process</span></h2>
        <p className="process__desc">A process where stainless steel material is cut into small diameter items with designs like chamfer, spherical radius, groove and straight end cut. All machines are operated by experienced and trained operators.</p>
        <div className="process__flow">
          {steps.map((step, i) => (
            <div className="process__step" key={i}>
              <div className="process__step-number">{String(i + 1).padStart(2, '0')}</div>
              <div className="process__step-img"><img src={step.img} alt={step.label} /></div>
              <h4 className="process__step-label">{step.label}</h4>
              {i < steps.length - 1 && <div className="process__step-arrow" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default EscomaticProcess;
